<template>
  <div class="wd-flex wd-items-center wd-gap-2 wd-bg-purple50 wd-bg-opacity-10 wd-px-5 wd-py-2 wd-cursor-pointer" @click.prevent="openPromoModal">
    <img class="wd-w-5 wd-h-5 wd-flex-shrink-0" src="@/assets/images/icon/aftee-promo-logo.svg?url" alt="AFTEE" loading="lazy" />

    <i18n-t keypath="product_detail_aftee_promo_banner" tag="p" class="!wd-mb-0 wd-text-sm wd-text-purple50">
      <template #rule>
        <span class="wd-cursor-pointer wd-underline !wd-text-inherit">
          {{ $t('product_detail_aftee_promo_banner_cta') }}
        </span>
      </template>
    </i18n-t>
  </div>

  <UiModal v-model="isPromoModalOpen" header-title="" :forcing="false" :hide-overlay="false" :close-icon="true">
    <div class="wd-px-5 wd-pt-2 wd-pb-0">
      <p class="wd-text-base wd-font-bold !wd-mb-1">{{ $t('product_detail_aftee_promo_1st_title') }}</p>
      <p class="wd-text-base wd-text-black50 !wd-mb-4">{{ $t('product_detail_aftee_promo_1st_content') }}</p>

      <p class="wd-text-base wd-font-bold !wd-mb-1">{{ $t('product_detail_aftee_promo_2nd_title') }}</p>
      <p class="wd-text-base wd-text-black50 !wd-mb-0">{{ $t('product_detail_aftee_promo_2nd_content') }}</p>
    </div>

    <template #buttons>
      <div class="wd-px-5 wd-pt-6 wd-pb-5 wd-flex wd-justify-end">
        <v-btn class="wd-w-full sm:wd-w-min" height="48" color="orange50" elevation="0" variant="flat" @click="closePromoModal">
          <span class="wd-text-lg">{{ $t('all_ok') }}</span>
        </v-btn>
      </div>
    </template>
  </UiModal>
</template>

<script setup lang="ts">
import UiModal from '@/components/dialog/ui-modal.vue'

defineOptions({
  name: 'AfteePromoHint',
})

const isPromoModalOpen = ref(false)

function openPromoModal() {
  isPromoModalOpen.value = true
}

function closePromoModal() {
  isPromoModalOpen.value = false
}
</script>
